export enum UserStatusType {
  NORMAL = "NOMARL",
  LEAVE = "LEAVE"
}